import { translation } from 'I18n/i18n'
import AnchorPart from 'components/anchorPart/anchorPart'
import ScrollContainer from 'components/scrollContainer/scrollContainer'
import ScrollSection from 'components/scrollSection/scrollSection'
import AnchorButtonContext from 'contexts/anchorButton'
import CounterContext from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import englishCondition from '../englishAssert'

interface IProps {
   visiteur?: boolean
}

export default function Groupe(props: IProps) {
   const lang = useSelector((state: any) => state.languageReducer.language)
   const { setCounter, counterDefault } = useContext(CounterContext)
   const { setHeadband } = useContext(HeadbandContext)
   const { setAnchorButton } = useContext(AnchorButtonContext)
   useEffect(() => {
      setCounter(counterDefault)
      setHeadband(translation(lang, 'groupe', 'title'))
      setAnchorButton(translation(lang, 'groupe', 'anchorButtons'))
   }, [])

   return (
      <ScrollContainer>
         <AnchorPart anchor={{ id: 0, partName: 'APTAR' }} />
         <ScrollSection zoneName={englishCondition(lang, props.visiteur) ? 'Aptar EN' : 'Aptar'} />
         <AnchorPart anchor={{ id: 1, partName: 'APTAR BEAUTY' }} />
         <ScrollSection
            zoneName={englishCondition(lang, props.visiteur) ? 'Aptar beauty EN' : 'Aptar beauty'}
            topInsertedElements={[
               <video
                  key={0}
                  src={`/video/Aptar Beauty Segment video 2023-20230117_081244.mp4`}
                  controls
                  loop
                  autoPlay
                  controlsList='nodownload nofullscreen noremoteplayback disablePictureInPicture'
                  muted
                  style={{ width: '1055px', paddingBottom: '-5px' }}
               />,
            ]}
         />
      </ScrollContainer>
   )
}
